import { DestroyRef, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { deepCopySync } from 'src/app/utility/deep-copy';

@Injectable({ providedIn: 'root' })
export class NavigationHistoryService {
  private readonly maxSize = 60;
  private history: string[] = new Array(this.maxSize);

  /**
   * Point of next insertion
   */
  private head = 0;
  private hasHistory = false;

  constructor(private readonly destroyRef: DestroyRef, router: Router) {

    const sub = router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.history[this.head] = event.urlAfterRedirects.length > 1000
          ? event.urlAfterRedirects.slice(0, 1000)
          : event.urlAfterRedirects;

        this.head = (this.head + 1) % this.maxSize;

        if (!this.hasHistory) {
          this.hasHistory = true;
        }
      });

    this.destroyRef.onDestroy(() => sub.unsubscribe());
  }


  /**
   * Returns the navigation history as an array from the most recent to the oldest.
   */
  public asArray(): string[] {
    if (!this.hasHistory) {
      return [];
    }

    const result = new Array<string>(this.maxSize);
    for (let i = 1; i <= this.maxSize; i++) {
      const idx = (this.head - i + this.maxSize) % this.maxSize;
      const url = this.history[idx];
      if (url != null && url !== undefined) {
        result.push(url); // most recent first
      }
    }


    return deepCopySync(result.filter(url => url !== undefined && url !== null));
  }
}
